import React from "react";
import { Modal } from "react-bootstrap";
import Context from "../../Context";
import Blocker from "../Misc/Blocker";
import EssenceActionsDropdown from "./EssenceActionsDropdown";
import EssenceStateLabel from "./EssenceStateLabel";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import unique from "array-unique";

let searchTimeout = null;

export default class EssenceReference extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      modalRef: React.createRef(),
      fileInputRef: React.createRef(),

      nameField: "name",
      pending: false,
      title: this.props.title || "Справочник",
      items: {},

      activeItemId: false,
      activeItem: {},
      activeItemRef: React.createRef(),
      activeItems: [],

      nestedData: {},
      itemEditorParams: {},
      editData: {},
      edit: false,
      types: [],
      textSearch: [],
      textSearchPending: false,
      textSearchValue: "",
      search: [],
      itemStateSearchDefault: [
        {
          lstr: "(",
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
          rstr: ")",
        },
      ],
      itemStateSearchAll: [],
      itemsShowAll: false,
      extraFields: [],
    };
  }
  componentDidMount() {
    this.setState({ nameField: this.props.nameField || "name" }, () => {
      if (this.props.show || this.props.onAfterLoad) {
        this.load();
      }
    });
    this.context.modalOpenedSet(this.props.show);
    this.restoreExtraFields();
    window.addEventListener("keydown", this.onKeyDown);
    window.addEventListener("keyup", this.onKeyUp);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show) {
      this.context.modalOpenedSet(this.props.show);
      if (this.props.show) {
        this.load();
      }
    }
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.onKeyDown);
    window.removeEventListener("keyup", this.onKeyUp);
  }

  onKeyDown = (e) => {
    if (this.props.show) {
      if (e?.key === "Shift") {
        this.setState({ shiftPressed: true });
      }
      if (e?.key === "a" && e?.ctrlKey) {
        e.preventDefault();
        this.onSelectAll();
      }
    }
  };

  onKeyUp = (e) => {
    if (this.props.show) {
      if (e?.key === "Shift") {
        this.setState({ shiftPressed: false });
      }
    }
  };

  onHide = () => {
    if (this.props.onHide) {
      this.props.onHide();
    }
    this.context.modalOpenedSet(false);
  };

  onSelectAll = () => {
    this.setState({
      activeItems: Object.keys(this.state.items),
      activeItemId: false,
      activeItem: {},
    });
  };

  onItemClick = (item, e = {}) => {
    const ctrl = e.ctrlKey ? true : false;
    const shift = e.shiftKey ? true : false;

    this.setState(({ activeItem, activeItems, activeItemId, items }) => {
      const unselect = ctrl && activeItems.includes(item.id);

      if (ctrl) {
        if (unselect) {
          activeItems = activeItems.filter((id) => id !== item.id);
        } else {
          activeItems.push(item.id);
          if (activeItemId) {
            activeItems.push(activeItemId);
          }
        }
      }

      if (!ctrl) {
        activeItems = [];
      }

      if (shift && !ctrl) {
        let started = false;
        let foundItems = [];
        Object.entries(items).forEach(([id, itm]) => {
          if (id === activeItemId || id === item.id) {
            started = !started;
            foundItems.push(id);
          } else {
            if (started) {
              foundItems.push(id);
            }
          }
        });

        activeItems = foundItems;
      }

      if (!unselect && !ctrl) {
        activeItemId = item.id;
        activeItem = item;
      }

      return {
        activeItemId,
        activeItem,
        activeItems: unique(activeItems),
      };
    });
  };
  onItemDblClick = (item) => {
    if (this.props.editOnDblClick) {
      this.onEditStart(item);
      return;
    }
    if (this.props.onSelect) {
      this.props.onSelect(item);
    }
    if (this.props.onHide) {
      this.props.onHide();
    }
  };
  onEditStart = (item) => {
    this.setState({
      activeItemId: item.id,
      activeItem: item,
      activeItems: [],
      edit: true,
      nestedData: item,
      editData: {
        name: item[this.state.nameField],
        description: item.description,
        type: item.type,
        node: item.node,
        code: item.code,
      },
    });
  };
  onCopyStart = (item) => {
    this.setState({
      edit: true,
      nestedData: item,
      editData: {
        add: true,
        name: item[this.state.nameField],
        description: item.description,
        type: item.type,
        node: item.node,
      },
    });
  };
  onAddStart = (defaultData = {}) => {
    this.setState({
      edit: true,
      nestedData: {},
      editData: Object.assign(
        {
          add: true,
          name: "",
          description: "",
          type: "",
          code: "",
        },
        defaultData
      ),
    });
  };
  onEditCancell = () => {
    this.setState(
      (state) => {
        return { edit: false, activeItems: [], editData: {}, nestedData: {} };
      },
      () => this.restoreScroll()
    );
  };
  onEditChange = (e) => {
    const value = e.target.value;
    const id = e.target.id;
    this.setState((state) => {
      let editData = state.editData;
      editData[id] = value;
      return { editData };
    });
  };
  onNestedDataChange = (data) => {
    this.setState({ nestedData: data });
  };

  onItemEditorInit = (params = {}) => {
    this.setState({ itemEditorParams: params });
  };

  onEditSave = async () => {
    let saveAsType =
      this.state.editData.type || this.context.getType(this.props.forceType);

    this.setState({ pending: true });
    let saveData = {
      id: this.state.editData.add ? null : this.state.activeItem.id,
      type: saveAsType || null,
      description: this.state.editData.description,
    };

    saveData[this.state.nameField] = this.state.editData.name;

    if (!this.props.hideCode) {
      saveData.code = this.state.editData.code;
    }
    if (this.props.structure) {
      if (this.state.editData.node) {
        saveData.node = this.state.editData.node;
      } else {
        if (this.state.activeItem.node) {
          saveData.node = this.context.api.nullUuid;
        } else {
          saveData.node = null;
        }
      }
    }
    if (this.props.itemEditor) {
      saveData = Object.assign(saveData, this.state.nestedData);
    }
    let result = await this.context.api.q(
      `/${this.props.essence}/set`,
      saveData
    );
    if (result !== false) {
      if (result.id) {
        if (this.state.itemEditorParams.onAfterSave) {
          await this.state.itemEditorParams.onAfterSave(result);
        }
        if (this.props.handleFile && this.state.fileInputRef.current) {
          if (this.state.fileInputRef.current.files[0]) {
            let files = [];

            const file = this.state.fileInputRef.current.files[0];
            const maxSize = window.appConfig.maxFileSize;

            if (maxSize && file.size > maxSize) {
              this.context.toast(
                `Превышен максимальный размер загружаемого файла: ${Math.round(
                  maxSize / 1024
                )} Кб`,
                "error"
              );
              this.setState({ pending: false });
              return;
            }

            let { encoded, type } = await this.context.api.toBase64(file);
            files.push({
              name: file.name,
              path: "", //file.path,
              size: file.size,
              date: file.lastModifiedDate,
              text: file.name,
              type: type,
              data: encoded,
            });

            let filesResult = await this.context.api.q("/object/file/set", {
              id: result.id,
              //clear: true,
              files,
            });

            if (!filesResult) {
              this.context.toast("Не удалось загрузить файлы", "error");
            }
          }
        }
      }

      this.context.toast("Элемент справочника сохранен", "success");
      await this.load();
      this.onItemClick(result);
      this.onEditCancell();
    } else {
      this.context.toast("Не удалось сохранить элемент справочника", "error");
      this.setState({ pending: false });
    }
  };

  onDragEnd = async (eventResult) => {
    const { draggableId, destination, source } = eventResult;
    const { items } = this.state;
    if (!eventResult.destination || !draggableId) {
      return;
    }

    const isUp = source.index > destination.index;
    const isDown = source.index < destination.index;

    if (!isUp && !isDown) return;

    const cIndex = isDown ? destination.index : destination.index - 1;

    const prevItem = items[Object.keys(items)[cIndex]] || false;
    const nextItem = items[Object.keys(items)[cIndex + 1]] || false;
    const currItem = items[`_${draggableId}`] || false;

    let node = null;
    let sequence = 1;

    if (prevItem.level < nextItem.level) {
      node = nextItem.node;
      sequence = 1;
    } else if (prevItem.level > nextItem.level || !nextItem) {
      node = prevItem.node;
      sequence = prevItem.sequence + 1;
    } else {
      node = nextItem.node;
      sequence = isUp ? nextItem.sequence : prevItem.sequence;
    }

    if (currItem.node === null) node = null;

    let saveData = {
      id: draggableId,
      node: node === null ? this.context.api.nullUuid : node,
      sequence,
    };

    this.setState({ pending: true });

    let result = await this.context.api.q(
      `/${this.props.essence}/set`,
      saveData
    );
    if (result !== false) {
      this.context.toast("Позиция элемента изменена", "success");
      await this.load();
      this.onItemClick(result);
      this.onEditCancell();
    } else {
      this.context.toast("Не удалось изменить позицию элемента", "error");
      this.setState({ pending: false });
    }
  };

  onTextSearchCancell = () => {
    let activeItem = this.state.activeItem;
    window.clearTimeout(searchTimeout);
    this.setState(
      {
        textSearchValue: "",
        textSearchPending: false,
        textSearch: [],
      },
      async (state) => {
        await this.load();
        this.onItemClick(activeItem);
        this.onEditCancell();
      }
    );
  };

  onTextSearch = (searchValue) => {
    this.setState({ textSearchValue: searchValue });
    this.setState({ textSearchPending: true });
    window.clearTimeout(searchTimeout);
    searchTimeout = window.setTimeout(() => {
      if (searchValue) {
        let textSearch = searchValue
          ? [
              {
                lstr: "(",
                field: "name",
                compare: "IKE",
                value: `%${searchValue}%`,
                rstr: ")",
              },
            ]
          : [];
        this.setState({ textSearchPending: false, textSearch }, () =>
          this.load()
        );
      } else {
        this.onTextSearchCancell();
      }
    }, 1000);
  };

  onShowAllToggle = (e) => {
    this.setState({ itemsShowAll: !e.target.checked }, () => this.load());
  };

  load = async () => {
    let accessEssence = this.props.accessEssence || this.props.essence;
    let access = this.context.user.classAccess[accessEssence] || {};
    if (access.a || this.context.user.isAdmin) {
      let search = this.state.itemsShowAll
        ? this.state.itemStateSearchAll
        : this.state.itemStateSearchDefault;

      if (this.props.forceType) {
        search.push({
          field: "typecode",
          compare: "EQL",
          value: this.props.forceType,
        });
      }

      this.setState({ pending: true });

      let items = {};
      if (this.props.structure && !this.state.textSearchValue) {
        items = await this.context.api.qoo(
          `/${this.props.essence}/list`,
          { search, reclimit: 0 },
          undefined,
          undefined,
          undefined,
          "node",
          this.props.sort || false
        );
      } else {
        items = await this.context.api.qo(`/${this.props.essence}/list`, {
          search: search.concat(this.state.textSearch),
        });
      }

      let types = this.props.forceType
        ? []
        : await this.context.api.qa(`/${this.props.essence}/type`);

      this.setState({ items, types, pending: false });

      if (this.props.onAfterLoad) {
        this.props.onAfterLoad(items);
      }
    } else {
      this.context.toast(
        `Доступ к справочнику "${this.props.title}" запрещен. Обратитесь к администратору`,
        "warning"
      );
    }
  };

  restoreExtraFields = () => {
    let extraFields = this.props.extraFields || [];
    if (this.props.showType) {
      extraFields.push("typename");
    }
    if (this.props.showDescription) {
      extraFields.push("description");
    }
    this.setState({ extraFields });
  };

  restoreScroll = () => {
    if (this.state.activeItemRef.current) {
      this.state.activeItemRef.current.scrollIntoView({ block: "center" });
    }
  };

  render() {
    let accessEssence = this.props.accessEssence || this.props.essence;
    let access = this.context.user.classAccess[accessEssence] || {};
    if (this.props.readOnly) {
      access.u = false;
      access.c = false;
    }

    let showitems = false;
    if (Object.keys(this.state.items).length > 0 && !this.state.edit) {
      showitems = true;
    }

    let showNotFound = false;
    if (!showitems && !this.state.edit && !this.state.pending)
      showNotFound = true;

    let showEdit = false;
    if (this.state.edit) showEdit = true;

    const notFound = (
      <div
        className="alert alert-custom alert-white alert-shadow fade show gutter-b"
        role="alert"
      >
        <div className="alert-icon">
          <i className="flaticon2-information text-dark-25"></i>
        </div>
        <div className="alert-text">По вашему запросу ничего не найдено</div>
      </div>
    );

    const editForm = (
      <div>
        <div className="row">
          <div className="form-group col-lg-12">
            <label>Наименование</label>
            <input
              id="name"
              value={this.state.editData.name || ""}
              onChange={this.onEditChange}
              type="text"
              className="form-control"
            />
          </div>
          {!this.props.hideCode && (
            <div className="form-group col-lg">
              <label>{this.props.codeLabel || "Код"}</label>
              <input
                id="code"
                value={this.state.editData.code || ""}
                onChange={this.onEditChange}
                type="text"
                className="form-control"
              />
            </div>
          )}

          {!this.props.forceType && (
            <div className="form-group col-lg">
              <label>Тип</label>
              <select
                id="type"
                value={this.state.editData.type}
                onChange={this.onEditChange}
                className="form-control"
              >
                {this.state.editData.add ? <option value=""></option> : null}
                {this.state.types.map((type) => (
                  <option value={type.id} key={type.code}>
                    {type.name}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
        {this.props.structure ? (
          <div className="form-group">
            <label>Родитель</label>
            <select
              id="node"
              value={this.state.editData.node || ""}
              onChange={this.onEditChange}
              className="form-control"
            >
              <option value=""></option>
              {Object.entries(this.state.items).map(([id, item]) => (
                <option value={item.id} key={id}>
                  {" . . ".repeat(item.level)} {item.name || item.label}
                </option>
              ))}
            </select>
          </div>
        ) : null}
        {this.props.showDescription ? (
          <div className="form-group">
            <label>Описание</label>
            <input
              id="description"
              value={this.state.editData.description || ""}
              onChange={this.onEditChange}
              type="text"
              className="form-control"
            />
          </div>
        ) : null}

        {this.props.handleFile ? (
          <div className="form-group">
            <label>Загрузить файл</label>
            <input
              ref={this.state.fileInputRef}
              type="file"
              className="form-control"
            />
          </div>
        ) : null}

        {this.props.itemEditor
          ? this.props.itemEditor({
              id: this.state.editData.add ? "add" : this.state.activeItemId,
              data: this.state.nestedData,
              onChange: this.onNestedDataChange,
              onInit: this.onItemEditorInit,
            })
          : null}
      </div>
    );

    const extraFields = (item) => {
      const colWidth = this.state.extraFields.length
        ? 50 / this.state.extraFields.length
        : 0;
      return (
        <>
          {this.state.extraFields.map((key) => (
            <td
              width={`${colWidth}%`}
              className="text-dark-50 font-italic font-size-sm"
              key={key}
            >
              {item[key]}
            </td>
          ))}
        </>
      );
    };

    const tableListClasses = ["table-responsive-no"];
    if (this.state.shiftPressed) tableListClasses.push("noselect");

    const itemsListDraggable = (
      <div className={tableListClasses.join(" ")}>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <table className="table">
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <tbody {...provided.droppableProps} ref={provided.innerRef}>
                  {Object.entries(this.state.items).map(([id, item], index) => (
                    <Draggable
                      key={item.id}
                      draggableId={String(item.id)}
                      index={index}
                    >
                      {(provided, snapshot) => {
                        const isActive =
                          item.id === this.state.activeItemId ||
                          this.state.activeItems.includes(item.id)
                            ? true
                            : false;

                        const padding = item.structureLevel
                          ? `pl-${item.structureLevel * 5}`
                          : "";

                        const dragging = snapshot.isDragging
                          ? "bg-light d-table "
                          : "";
                        return (
                          <tr
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            onClick={(e) => this.onItemClick(item, e)}
                            onDoubleClick={() => this.onItemDblClick(item)}
                            key={id}
                            className={`bg-hover-light cursor-pointer ${
                              isActive ? "bg-light" : ""
                            }  ${padding} ${dragging}`}
                          >
                            <td
                              width="45%"
                              ref={isActive ? this.state.activeItemRef : null}
                              className={`${padding}`}
                            >
                              {item.name || item.label}
                            </td>
                            {extraFields(item)}
                            <td width="10%" className="text-right text-nowrap">
                              {this.state.itemsShowAll ? (
                                <EssenceStateLabel
                                  id={item.id}
                                  stateCode={item.statetypecode}
                                  stateLabel={item.statelabel}
                                  essence={this.props.essence}
                                />
                              ) : null}

                              {access.u === true ? (
                                <span
                                  title="Копировать"
                                  onClick={() => this.onCopyStart(item)}
                                  className="flaticon2-copy px-2 align-middle text-muted  cursor-pointer  text-hover-dark"
                                ></span>
                              ) : null}

                              {access.u === true ? (
                                <span
                                  title="Изменить"
                                  onClick={() => this.onEditStart(item)}
                                  className="flaticon2-edit px-2 align-middle text-muted  cursor-pointer  text-hover-dark"
                                ></span>
                              ) : null}

                              {access.c === true && this.props.structure ? (
                                <span
                                  title="Добавить элемент сюда"
                                  onClick={() =>
                                    this.onAddStart({ node: item.id })
                                  }
                                  className="flaticon2-add-1 px-2 align-middle text-muted  cursor-pointer  text-hover-dark"
                                ></span>
                              ) : null}

                              <div className="d-inline-block align-middle ml-2">
                                <EssenceActionsDropdown
                                  className="px-2"
                                  attendantItems={this.state.activeItems || []}
                                  essence={this.props.essence}
                                  key={`${item.id}${item.state}`}
                                  id={item.id}
                                  label={item.label}
                                  onFinish={() => this.load()}
                                  onPending={(pending) => {
                                    if (pending)
                                      this.setState({ pending: true });
                                  }}
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      }}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </tbody>
              )}
            </Droppable>
          </table>
        </DragDropContext>
      </div>
    );

    const itemsListUsual = (
      <div className={tableListClasses.join(" ")}>
        <table className="table">
          <tbody>
            {Object.entries(this.state.items).map(([id, item], index) => {
              const isActive =
                item.id === this.state.activeItemId ||
                this.state.activeItems.includes(item.id)
                  ? true
                  : false;

              const padding = item.structureLevel
                ? `pl-${item.structureLevel * 5}`
                : "";

              return (
                <tr
                  onClick={(e) => this.onItemClick(item, e)}
                  onDoubleClick={() => this.onItemDblClick(item)}
                  key={id}
                  className={`bg-hover-light-primary cursor-pointer ${
                    isActive ? "bg-light" : ""
                  }  ${padding}`}
                >
                  <td
                    width="40%"
                    ref={isActive ? this.state.activeItemRef : null}
                    className={`${padding}`}
                  >
                    {item.name || item.label}
                  </td>
                  {extraFields(item)}
                  <td width="10%" className="text-right text-nowrap">
                    {this.state.itemsShowAll ? (
                      <EssenceStateLabel
                        id={item.id}
                        stateCode={item.statetypecode}
                        stateLabel={item.statelabel}
                        essence={this.props.essence}
                      />
                    ) : null}

                    {access.u === true ? (
                      <span
                        title="Копировать"
                        onClick={() => this.onCopyStart(item)}
                        className="flaticon2-copy px-2 align-middle text-muted  cursor-pointer  text-hover-dark"
                      ></span>
                    ) : null}

                    {access.u === true ? (
                      <span
                        title="Изменить"
                        onClick={() => this.onEditStart(item)}
                        className="flaticon2-edit px-2 align-middle text-muted  cursor-pointer  text-hover-dark"
                      ></span>
                    ) : null}

                    {access.c === true && this.props.structure ? (
                      <span
                        title="Добавить элемент сюда"
                        onClick={() => this.onAddStart({ node: item.id })}
                        className="flaticon2-add-1 px-2 align-middle text-muted  cursor-pointer  text-hover-dark"
                      ></span>
                    ) : null}

                    <div className="d-inline-block align-middle ml-2">
                      <EssenceActionsDropdown
                        className="px-2"
                        essence={this.props.essence}
                        key={`${item.id}${item.state}`}
                        id={item.id}
                        attendantItems={this.state.activeItems || []}
                        label={item.label}
                        onFinish={() => this.load()}
                        onPending={(pending) => {
                          if (pending) this.setState({ pending: true });
                        }}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );

    let itemsList = null;
    if (showitems) {
      if (this.props.draggable && !this.state.textSearchValue) {
        itemsList = itemsListDraggable;
      } else {
        itemsList = itemsListUsual;
      }
    }

    return (
      <>
        <Modal size="xl" show={this.props.show} onHide={this.onHide}>
          <Modal.Header closeButton>
            <Modal.Title className="w-100">
              <div className=" d-flex justify-content-between align-items-center">
                <div>
                  {this.state.title}
                  {!this.state.edit ? (
                    <div className="text-nowrap d-inline-block ml-4">
                      <label
                        title="Показывать элементы справочника в любом статусе"
                        className="checkbox text-muted font-italic"
                      >
                        <input
                          checked={!this.state.itemsShowAll}
                          onChange={this.onShowAllToggle}
                          type="checkbox"
                        />
                        <span className="mr-2"></span>
                        Только активные
                      </label>
                    </div>
                  ) : null}
                </div>
                {!this.state.edit ? (
                  <div>
                    <div className="text-nowrap d-inline-block mr-2">
                      {this.state.textSearchPending ? (
                        <div className="spinner mr-10 d-inline-block"></div>
                      ) : (
                        ""
                      )}
                      <div className="d-inline-block">
                        <div className="input-group">
                          <input
                            className="form-control form-control-solid d-inline-block w-auto"
                            type="text"
                            placeholder="Поиск"
                            value={this.state.textSearchValue}
                            onChange={(e) => this.onTextSearch(e.target.value)}
                          />
                          {this.state.textSearchValue ? (
                            <div className="input-group-append">
                              <button
                                title="Отменить поиск"
                                className="btn btn-icon btn-secondary"
                                type="button"
                                onClick={() => this.onTextSearchCancell()}
                              >
                                <i className="fa text-muted fa-close"></i>
                              </button>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    {access.c === true ? (
                      <button
                        title="Добавить элемент"
                        onClick={() => this.onAddStart()}
                        className="btn btn-light mr-2 text-hover-primary"
                      >
                        <i className="flaticon2-add-1 p-0 align-middle text-muted"></i>
                      </button>
                    ) : null}
                    {this.props.appendButtons}
                  </div>
                ) : null}
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Blocker
              on={this.state.pending}
              spinnerFixed={
                Object.keys(this.state.items).length > 0 ? true : false
              }
              solid
            >
              {showitems ? itemsList : null}
              {showNotFound ? notFound : null}
              {showEdit ? editForm : null}
            </Blocker>
          </Modal.Body>
          {showEdit ? (
            <Modal.Footer>
              <button
                onClick={this.onEditSave}
                className="btn btn-primary mr-2"
              >
                Сохранить
              </button>
              <button onClick={this.onEditCancell} className="btn btn-light">
                Отмена
              </button>
            </Modal.Footer>
          ) : (
            <Modal.Footer>
              <button
                ref={this.state.modalRef}
                onClick={this.onHide}
                className="btn btn-light"
              >
                Закрыть
              </button>
            </Modal.Footer>
          )}
        </Modal>
      </>
    );
  }
}
